export interface LegendItem {
  id: string;
  label: string;
  color: string;
  hidden?: boolean;
}

export interface LegendProps {
  items: readonly LegendItem[];
  /** Makes entries toggle buttons (series visibility). */
  onToggle?: (id: string) => void;
  /** Accessible name for the legend. */
  label: string;
}

/** Series legend. Identity never relies on colour alone: every swatch has a text label. */
export function Legend({ items, onToggle, label }: LegendProps) {
  return (
    <ul aria-label={label} className="flex flex-wrap items-center gap-x-3 gap-y-1">
      {items.map((item) => {
        const content = (
          <>
            <span
              aria-hidden
              className="inline-block h-0.5 w-3 rounded-full"
              style={{ background: item.color, opacity: item.hidden ? 0.35 : 1 }}
            />
            <span className={item.hidden ? 'text-text-3 line-through' : 'text-text-2'}>
              {item.label}
            </span>
          </>
        );
        return (
          <li key={item.id}>
            {onToggle ? (
              <button
                type="button"
                aria-pressed={!item.hidden}
                onClick={() => {
                  onToggle(item.id);
                }}
                className="inline-flex items-center gap-1.5 rounded-sm text-xs outline-none hover:text-text-1 focus-visible:ring-2 focus-visible:ring-focus"
              >
                {content}
              </button>
            ) : (
              <span className="inline-flex items-center gap-1.5 text-xs">{content}</span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
